export class NavBarService {

  searchFilter = '';

  constructor() {}

}
